import React from "react";
import { useParams, Navigate } from "react-router-dom";
import IndustryTemplate from "@/components/templates/IndustryTemplate";
import { INDUSTRY_PAGES } from "@/data/industries";

const IndustryPage = () => {
  const { slug } = useParams();
  const data = INDUSTRY_PAGES[slug];
  if (!data) return <Navigate to="/" replace />;
  return <IndustryTemplate data={data} />;
};

export default IndustryPage;
